import React, { useContext } from 'react';
import {
  CSidebar,
  CSidebarBrand,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavItem,
  CSidebarNav,
  CImg,
} from '@coreui/react';
import * as pluralize from 'pluralize';

import './styles/GeneralLayoutSideMenu.scss';

import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import logo from '../assets/images/glympse-pro-white.png';
import logoMinimized from '../assets/images/Glympse-Pro-Logo-Transparent-Adaptive-Inner.png';
import { ConfigContext } from '../shared/contexts/journeyConfig.context';
import { isInactiveSubscription } from '../shared/utils/chargebee-utils';
import { selectUserOrganization } from '../store/selectors/store.selectors';
import OrgHierarchyButton from '../shared/components/orgHierarchy/OrgHierarchyButton';

export type SideBarState = '' | true | false | 'responsive';

export interface GeneralLayoutSideMenuProps {
  showMenu: SideBarState;
  onMenuToggle: (val: SideBarState) => void;
}

const GeneralLayoutSideMenu = (props: GeneralLayoutSideMenuProps) => {
  const { showMenu, onMenuToggle } = props;
  const org = useSelector(selectUserOrganization);

  const {
    enableCustomizationModule,
    enableInsightsModule,
    enableJobsModule,
    enableDashboardModule,
    enableTechniciansModule,
    enableChargebeeModule,
    enableLiveMapModule,
    enableInternalSignUp,
  } = useFlags();

  const labels = useContext(ConfigContext);

  return (
    <CSidebar
      show={showMenu}
      onShowChange={onMenuToggle}
      className="sidebar-container"
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        <CImg
          className="c-sidebar-brand-full"
          src={logo}
          height="30"
        />
        <CImg
          className="c-sidebar-brand-minimized"
          src={logoMinimized}
          height="60"
        />
      </CSidebarBrand>
      <CSidebarNav>
        <OrgHierarchyButton className="glympse-orgHierarchy-sidebar"/>
        <CSidebarNavTitle>Navigation</CSidebarNavTitle>
        {
          (!enableChargebeeModule || !isInactiveSubscription(org)) &&  enableDashboardModule && <CSidebarNavItem
            name="Dashboard"
            to="/dashboard"
            icon="cil-speedometer"
          />
        }
        {
          (!enableChargebeeModule || !isInactiveSubscription(org)) &&  enableLiveMapModule && <CSidebarNavItem
            name="Live Map"
            to="/dashboard/livemap"
            icon="cil-map"
          />
        }
        {
          (!enableChargebeeModule || !isInactiveSubscription(org)) && enableJobsModule && <CSidebarNavItem
          name={`${pluralize(labels.task)}`}
          to="/jobs/search"
          icon="cil-clock"
          />
        }
        {
          (!enableChargebeeModule || !isInactiveSubscription(org)) && enableTechniciansModule && <CSidebarNavItem
          name={`${pluralize(labels.agent)}`}
          to="/technicians"
          icon="cil-user"
          />
        }
        {
          (!enableChargebeeModule || !isInactiveSubscription(org)) && enableInsightsModule && <CSidebarNavItem
            name="Insights"
            to="/insights"
            icon="cil-chart-line"
          />
        }
        {
          (!enableChargebeeModule || !isInactiveSubscription(org)) && enableCustomizationModule && <CSidebarNavItem
            name="Customize"
            to="/customize"
            icon="cil-settings"
          />
        }
        {
          enableInternalSignUp && <CSidebarNavItem
            name="Internal Sign Up"
            to="/internal-sign-up"
            icon="cil-user"
          />
        }
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  );
};

export default React.memo(GeneralLayoutSideMenu);
